//dependencies import ==>
import React from "react";
//css and assets import ==>
import "./uploadToggelButton.scss";
import Checked from "../../../assets/checked.png";

const UploadToggleButton = (props) => {
  //const ==>
  const { isSelected, handelSelect, titleImg, title } = props;
  //<==

  //create UI ==>
  const createTitleImageUI = () => {
    return (
      <div
        className="card-body custom-column "
        onClick={() => {
          if (handelSelect) {
            handelSelect();
          }
        }}
      >
        {isSelected && (
          <img
            src={Checked}
            height="20"
            width="20"
            className="selected-card"
            style={{
              display: "block",
            }}
            alt="checkImage"
          />
        )}
        <div className="icon-container">
          <img
            src={titleImg}
            style={{
              width: "25px",
            }}
            alt="upload"
          />
          <span className="accordian-body_heading">{title}</span>
        </div>
      </div>
    );
  };
  //<==

  return (
    <div className="upload-toggle-button">
      <div className="upload-main-button ">
        <div
          className={`card card_style cursor-pointer ${
            isSelected == true ? "active-card" : ""
          }`}
        >
          {createTitleImageUI()}
        </div>
      </div>
    </div>
  );
};

export default UploadToggleButton;
